module.exports = __webpack_public_path__ + "1793882494189/fonts/Flaticon.bb9d9c1.eot";